import { useState, useEffect } from "react";

const ProgressBar = (val) => {

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

  useEffect(() => {
    const updateScreenSize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  return <div
    className={`d-flex justify-content-center align-items-center align-self-center ${isMobile ? `flex-column` : `flex-row`}`}
    style={{ marginTop: '25px', width: isMobile ? '100%' : '45%', maxWidth: isMobile ? '' : '385px' }}>

    <span className='dca-dashboard-introflow-step-text' style={{ margin: '0 15px 0 0' }}>{val.stepText}</span>

    <div style={{ width: '35%' }}>
      <div
        className="progress"
        style={{ height: "13px", borderRadius: '0px' }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{
            width: `${val.value}%`,
            backgroundColor: '#00E282'
          }}
          aria-valuenow={val.value}
          aria-valuemin={0}
          aria-valuemax={100}
        >
        </div>
      </div>
    </div>
  </div>
}

export { ProgressBar }
